<div class="col" [class.selected]="selectedCol === reponse" [attr.data-index]="index + 1">
    <h3>{{ reponse }}</h3>
  </div>
  